import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var CategoryDetailsRes;
export const CategoryDetailsTodo = createAsyncThunk('CategoryDetails', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + `vehicle_category/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return CategoryDetailsRes = res.data

    } catch (error) {
        return CategoryDetailsRes = error.response.data
    }
})

const CategoryDetailsSlice = createSlice({
    name: 'CategoryDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(CategoryDetailsTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(CategoryDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default CategoryDetailsSlice.reducer; 